import React, { useCallback, useEffect, useState } from 'react'
import { CircularProgress, Tabs, Tab } from '@material-ui/core'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

import { Page, Header, CustomTable } from 'components'
import { useExameSolicitadoService } from 'hooks/useExameSolicitadoService'
import useRouter from 'utils/useRouter'
import { useStyles } from './ExamesSolicitadosDoSetor.styles'

export const ExamesSolicitadosDoSetor = (props) => {
  const { route } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const router = useRouter()
  const exameSolicitadoService = useExameSolicitadoService()

  const [tabValue, setTabValue] = useState(0)
  const [examesPendentes, setExamesPendentes] = useState([])
  const [examesEmAndamento, setExamesEmAndamento] = useState([])
  const [examesTodos, setExamesTodos] = useState([])

  const [processandoPendentes, setProcessandoPendentes] = useState(true)
  const [processandoEmAndamento, setProcessandoEmAndamento] = useState(true)
  const [processandoTodos, setProcessandoTodos] = useState(true)

  const fetchExamesPendentes = useCallback(async () => {
    try {
      const response = await exameSolicitadoService.listarExamesPendentesDeSetoresDoUsuarioAsync(setProcessandoPendentes)
      setExamesPendentes(response || [])
    } catch (error) {
      console.error('Erro ao buscar exames pendentes:', error)
      setProcessandoPendentes(false)
    }
  }, [])

  const fetchExamesEmAndamento = useCallback(async () => {
    try {
      const response = await exameSolicitadoService.listarExamesEmAndamentoDeSetoresDoUsuarioAsync(setProcessandoEmAndamento)
      setExamesEmAndamento(response || [])
    } catch (error) {
      console.error('Erro ao buscar exames em andamento:', error)
      setProcessandoEmAndamento(false)
    }
  }, [])

  const fetchExamesTodos = useCallback(async () => {
    try {
      const response = await exameSolicitadoService.listarExamesDeSetoresDoUsuarioAsync(setProcessandoTodos)
      setExamesTodos(response || [])
    } catch (error) {
      console.error('Erro ao buscar todos os exames:', error)
      setProcessandoTodos(false)
    }
  }, [])

  useEffect(() => {
    fetchExamesPendentes()
    fetchExamesEmAndamento()
    fetchExamesTodos()
  }, [fetchExamesPendentes, fetchExamesEmAndamento, fetchExamesTodos])

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const handleRowClick = (idExame) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${idExame}`)
  }

  const colunas = [
    {
      title: 'Identificador',
      field: 'exReal.numeroExame',
      cellStyle: { fontWeight: 600, width: '15%', minWidth: '120px' },
      render: (rowData) => rowData.exReal?.numeroExame || '-',
    },
    {
      title: 'Tipo',
      field: 'tipoEx.nome',
      render: (rowData) => rowData.tipoEx?.nome?.toUpperCase() || '-',
      cellStyle: { minWidth: '150px' },
    },
    {
      title: 'Setor responsável',
      field: 'setor.nome',
      render: (rowData) => rowData.setor?.nome?.toUpperCase() || '-',
      cellStyle: { minWidth: '180px' },
    },
    {
      title: 'Solicitado em',
      field: 'solEx.data',
      render: (rowData) => (rowData.solEx?.data ? moment(rowData.solEx.data).format('DD/MM/YYYY HH:mm') : '-'),
      cellStyle: { width: '15%', minWidth: '160px' },
      defaultSort: 'desc',
    },
    {
      title: 'Status',
      field: 'exReal.status',
      render: (rowData) => rowData.exReal?.status?.toUpperCase() || 'PENDENTE',
      cellStyle: { width: '12%', minWidth: '120px' },
    },
  ]

  const estaCarregando = tabValue === 0 ? processandoPendentes : tabValue === 1 ? processandoEmAndamento : processandoTodos

  const dadosTabela = tabValue === 0 ? examesPendentes : tabValue === 1 ? examesEmAndamento : examesTodos

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.secao}`} overline={route.secao} />

      <div className={classes.tabsContainer}>
        <Tabs value={tabValue} onChange={handleTabChange} indicatorColor="primary" textColor="primary" aria-label="Abas de Filtros de Exames Solicitados do Setor">
          <Tab label="Pendentes" className={classes.tab} />
          <Tab label="Em Andamento" className={classes.tab} />
          <Tab label="Todos" className={classes.tab} />
        </Tabs>
      </div>

      {estaCarregando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <CustomTable columns={colunas} data={dadosTabela} onRowClick={(event, rowData) => handleRowClick(rowData.id)} searchPlaceholder="Buscar exames..." emptyDataSourceMessage="Nenhum exame solicitado do setor encontrado" />
      )}
    </Page>
  )
}
